export default class SpecialRequestCreateRequest {
  /**
   * @param {number} reasonRequest
   * @param {number} localizingMaterials
   * @param {string} detailsOtherLocalizingMaterials
   * @param {string[]} vehicleTypes
   * @param {string} detailsOtherVehiculeType
   * @param {EquipmentTypeElem[]} specialRequestEquipmentslist
   * @param {string} commentary
   * @param {string} answer
   * @param {number} status
   * @param {Date} creationDate
   * @param {Date} startingAvailabilityDatetime
   * @param {Date} endingAvailabilityDateTime
   * @param {AddressDto} wishedMeetingAddress
   * @param {number} specialRequestContact
   */
  constructor({
                reasonRequest,
                localizingMaterials,
                detailsOtherLocalizingMaterials,
                vehicleTypes,
                detailsOtherVehiculeType,
                specialRequestEquipmentslist,
                commentary,
                answer,
                status,
                creationDate,
                startingAvailabilityDatetime,
                endingAvailabilityDateTime,
                wishedMeetingAddress,
                specialRequestContact
              }) {
    this.reasonRequest = reasonRequest;
    this.localizingMaterials = localizingMaterials;
    this.detailsOtherLocalizingMaterials = detailsOtherLocalizingMaterials;
    this.vehicleTypes = vehicleTypes;
    this.detailsOtherVehiculeType = detailsOtherVehiculeType;
    this.specialRequestEquipmentslist = specialRequestEquipmentslist;
    this.commentary = commentary;
    this.answer = answer;
    this.status = status;
    this.creationDate = creationDate;
    this.startingAvailabilityDatetime = startingAvailabilityDatetime;
    this.endingAvailabilityDateTime = endingAvailabilityDateTime;
    this.wishedMeetingAddress = wishedMeetingAddress;
    this.specialRequestContact = specialRequestContact;
  }
}
